import React from 'react';
import { Header, Grid, Segment } from 'semantic-ui-react';
import axios from 'axios';
import DefaultHomePage from '../Home/DefaultHomePage';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class EmploymentServiceCSHome extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div >
                    <DefaultHomePage/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/EmploymentServiceCS/EmploymentServiceCSHome.js